import {useState} from 'react';
import {AppBar,Box,Toolbar,IconButton, Typography,Menu , Container,Button,MenuItem,ThemeProvider} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import theme from "../../theme";
import imageTop from "../../assets/wave4.svg";
import {NavLink} from "react-router-dom";
import {Link} from 'react-scroll'

const pages = [
    {
    name:'O pasiece',
    link:'about'
    },

    {
    name:'Nasze miody',
    link:'our_honeys'
    },

    {
    name:'Współpraca',
    link:'colaboration'
    },

    {
        name:'Kontakt',
        link:'contact'
    },

];

const logo = require('../../assets/logo bez tla.png');


const Header =() => {
    const [anchorElNav, setAnchorElNav] = useState(null);


    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    return (
        <ThemeProvider theme={theme}>
            <AppBar
                position="static"
                sx ={{
                    backgroundColor:{xs:'#F3D188', md:'transparent'},
                    boxShadow:0,
                    backgroundImage: {xs:'none', md:`url(${imageTop})`},
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    height: { xs: '120px', md: '170px',lg: '220px', xl: '360px'},
                }}>
                <Container maxWidth="xl" id='header'>
                    <Toolbar disableGutters>

                        <Box
                            sx={{
                                mr: 3,
                                display: 'flex',
                                height: { xs: '100px',lg: '150px', xl: '170px'},
                                width: { xs: '140px',lg: '210px', xl: '240px'},
                                ml:{ xs: 5, md: 12, lg: 17,xl:15 },
                                mt:{ xs: 2, xl:3 },
                            }}>
                            <img src={logo} alt='logo' />
                        </Box>

{/* widok dla ponizej 900px */}
                        <Box sx={{
                            flexGrow: 1,
                            display: { xs: 'flex', md: 'none' },
                             justifyContent:'flex-end',
                        }}>
                            <IconButton
                                aria-label="Otwórz menu nawigacji"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleOpenNavMenu}
                                sx={{
                                    mb:6,
                                    mr: 3,
                                    mt:'20px', 
                                    color: 'black'
                                }}
                            >
                                <MenuIcon sx={{
                                    fontSize: '30px',
                                    color: 'black'
                                }}/>
                            </IconButton>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorElNav}
                                anchorOrigin={{
                                    // vertical: 'bottom',
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                                open={Boolean(anchorElNav)}
                                onClose={handleCloseNavMenu}
            //                     sx={{
            //                         display: { xs: 'block', md: 'none' },
            //                         // backgroundColor: '#FEEEB2'
            //                         // mb:3,
            //                         // mt:'53px',
            //                         // width:'100vw',
                                    
            //                          width: '100vw', 
            // mt: '110px',
            // left: 0,
            // right: 0,
            // top:0,
            // position: 'fixed', 
            // backgroundColor: '#fff', 
            // borderRadius: 0,
            // zIndex: 1200,
            // boxShadow: 3

            //                     }}

                                PaperProps={{
                                    sx: {
                                        width: '100vw', 
                                        mt: '110px', 
                                        left: 0,
                                        right: 0,
                                        top:0,
                                        position: 'fixed', 
                                        backgroundColor: '#fff',
                                        borderRadius: 0,
                                        zIndex: 1200,
                                        boxShadow: 3
                                    }
                                }}
                                sx={{
                                    display: { xs: 'block', md: 'none' }
                                }}
                                
                            >
                          
                                {pages.map((page) => (
                                    <Link key={page.name} to={page.link} spy={true} smooth={true} onClick={handleCloseNavMenu} style={{
                                                    textDecoration:'none',
                                                    color: 'black',
                                                    width: '100%',
                                                    display: 'block',
                                                    padding: '2px 0'
                                        }}>
                                        <MenuItem  sx={{ px: 2, py: 1.5, width: '100%', cursor: 'pointer' }} >

                                            <Typography textAlign="center">
                                            {page.name}
                                            </Typography>
                                       
                                        </MenuItem>
                                    </Link>
                                ))}

                            </Menu>
                        </Box>

{/* widok dla powyzej 900px */}
                        <Box
                            sx={{
                                flexGrow: 1,
                                display: { xs: 'none', md: 'flex' },
                                justifyContent:'flex-end' }}>
                     
                            {pages.map((page) => (
                                <Link key={page.name} to={page.link} onClick={handleCloseNavMenu} spy={true} smooth={true} style={{
                                        textDecoration:'none',
                                        color: 'black'
                                    }}>
                                <Button sx={{ 
                                    mb: 5,
                                    color: 'black',
                                    display: 'block' ,
                                    fontWeight: 700,
                                    fontSize: { md: '14px', lg: '16px', xl: '18px' }
                                    }}>
                                   
                                    {page.name}
                                
                                </Button>
                                </Link>
                                ))}

                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>
        </ThemeProvider>
    );
}
export default Header;